export function removeNode(node: HTMLElement) {
    node.parentNode?.removeChild(node);
}
